import { ArticleBrandId } from "entities/manageArticles/types";
import { StyledManageArticlesLayout } from "modules/manageArticles/styled";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import PageHeading from "shared/components/PageHeading";
import SideBarManageArticles from "../SideBarManageArticles";

const ManageArticlesLayout: FC<PropsWithChildren> = ({ children }) => {
  const { brandId = ArticleBrandId.INTERNATIONAL } = useParams();

  return (
    <FlexColumn className="grid-page-layout" pr={"1.5rem"}>
      <FlexCenter px={"1.5rem"}>
        <PageHeading />
      </FlexCenter>
      <StyledManageArticlesLayout>
        <SideBarManageArticles brandId={brandId as ArticleBrandId} />
        {children}
      </StyledManageArticlesLayout>
    </FlexColumn>
  );
};

export default ManageArticlesLayout;
